import React from 'react';
import {Collapse, theme} from 'antd';
import {RightOutlined} from '@ant-design/icons';

const MACROS: [string, string][] = [
    ['{ADVERTISER}', 'Advertiser ID'],
    ['{AD_ID}', 'Creative ID'],
    ['{AD_HEIGHT}', 'Creative height'],
    ['{AD_WIDTH}', 'Creative height'],
    ['{BANNER}', 'Creative ID'],
    ['{CAMPAIGN}', 'Campaign ID'],
    ['{SITE_ID}', 'Site ID'],
    ['{CLICK_ID}', 'Click ID'],
    ['{CLICK_URL}', 'Click event URL'],
    ['{CLICK_URL_ENC}', 'Click event URL (encoded)'],
    ['{COUNTRY}', 'Country iso3 code'],
    ['{IP}', 'Device IP'],
    ['{OS}', 'Device OS'],
    ['{REFERRER}', 'Referrer page'],
    ['{REFERRER_DOMAIN}', 'Referrer domain'],
    ['{IMP_PIXEL}', 'Impression pixel'],
    ['{THIRD_URL}', '3rd party tracking url'],
    ['{SSP}', 'SSP name'],
    ['{TRACKING_ID}', 'Tracking ID'],
    ['{VAST_START}', 'VAST start event URL'],
    ['{VAST_FIRST_QUARTILE}', 'VAST first quartile event URL'],
    ['{VAST_MIDPOINT}', 'VAST midpoint event URL'],
    ['{VAST_THIRD_QUARTILE}', 'VAST third quartile event URL'],
    ['{VAST_COMPLETE}', 'VAST complete event URL'],
    ['{VAST_VERSION}', 'VAST version']
];

export const MacroGuide: React.FC = () => {
    const {token} = theme.useToken();
    return (
        <Collapse
            bordered={false}
            expandIcon={({isActive}) => <RightOutlined style={{color: token.colorText}} rotate={isActive ? 90 : 0}/>}
            style={{margin: '3px 0 6px 0', borderColor: token.colorBorder, background: token.colorBgContainer}}
        >
            <Collapse.Panel
                key="macro-guide"
                style={{background: token.colorBgContainer}}
                header={<span style={{color: token.colorText}}>Macro guide</span>}
            >
                {MACROS.map(([m, d]) => (
                    <p key={m} style={{color: token.colorText, marginLeft: 50}}>
                        {m}: {d}
                    </p>
                ))}
            </Collapse.Panel>
        </Collapse>
    );
};